module.exports = __webpack_public_path__ + "static/d7228a73a798797339e129bd8b7a558a09e5e8c4ea48729b40a319dd32755cdf-a6260202dd8081823a6ec949dc519aca.png";